export const decodeHtmlCharCodes = str =>
  str
    ? str.replace(/(&#(\d+);)/g, (match, capture, charCode) =>
        String.fromCharCode(charCode),
      )
    : null;
